import { faLaptop } from '@fortawesome/pro-light-svg-icons/faLaptop';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Agent } from '@propertypal/shared/src/types/property';
import Link from 'next/link';
import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Hr } from '../layout';
import { Heading, Text } from '../typography';
import ModalWrapper from './ModalWrapper';
import {
  Content,
  Container,
  HeaderBlock,
  CloseButton,
  Logo,
  SubtitleBlock,
  LinksContainer,
  LinkItem,
  Icon,
} from './WhiteModal.style';

interface Props {
  ariaLabel?: string;
  show: boolean;
  onClose: () => void;
  closeRef?: React.RefObject<HTMLButtonElement>;
  title?: string;
  subtitle?: JSX.Element | string;
  logo?: string;
  maxWidth?: number;
  stMaxWidth?: number;
  contentStyle?: CSSProperties;
  agent?: Agent;
}

const WhiteModal: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <ModalWrapper show={props.show} onClose={props.onClose}>
      <Container>
        <HeaderBlock>
          {props.logo && <Logo data-testid="logo" src={props.logo} />}

          {props.title && <Heading data-testid="title">{props.title}</Heading>}
        </HeaderBlock>

        {props.subtitle && (
          <SubtitleBlock data-testid="subtitle" stMaxWidth={props.stMaxWidth}>
            <Text fontSize={18} fontWeight="600" as={typeof props.subtitle === 'object' ? 'span' : undefined}>
              {props.subtitle}
            </Text>
          </SubtitleBlock>
        )}

        <Content maxWidth={props.maxWidth} style={props.contentStyle}>
          <CloseButton
            ref={props.closeRef}
            onClick={props.onClose}
            aria-label="Close enquiry modal"
            data-testid="closeModalButton"
          >
            <FontAwesomeIcon icon={faTimes} color={theme.backgroundDark} style={{ fontSize: 32, margin: 10 }} />
          </CloseButton>

          {props.children}
        </Content>

        {props.agent && !props.agent.developer && (
          <>
            <Hr style={{ marginTop: '20px', maxWidth: '1024px' }} />

            <LinksContainer>
              {props.agent.landingPageUrl && (
                <Link href={props.agent.landingPageUrl} passHref>
                  <a>
                    <LinkItem data-testid="landingLink">
                      <Icon>
                        <FontAwesomeIcon color="#4a4a4a" icon={faPaperPlane} size="lg" />
                      </Icon>
                      <Text fontSize={10} style={{ marginLeft: '10px' }}>
                        Request a Valuation from {props.agent.organisation}
                      </Text>
                    </LinkItem>
                  </a>
                </Link>
              )}

              {props.agent.websiteUrl && (
                <Link href={props.agent.websiteUrl} passHref>
                  <a>
                    <LinkItem data-testid="websiteLink">
                      <Icon>
                        <FontAwesomeIcon color="#4a4a4a" icon={faLaptop} size="lg" />
                      </Icon>
                      <Text fontSize={10} style={{ marginLeft: '10px' }}>
                        Visit {props.agent.organisation} Website
                      </Text>
                    </LinkItem>
                  </a>
                </Link>
              )}
            </LinksContainer>
          </>
        )}
      </Container>
    </ModalWrapper>
  );
};

export default WhiteModal;
